import { Head, usePage } from "@inertiajs/react";
import pageTitle from "~/utils/pageTitle.js";
import Hero2 from "~/components/Hero2.jsx";
import Services from "@/components/home/Services/Services.jsx";
import Features from "@/components/home/Features/Features.jsx";
import ProductsSelection from "@/components/products/ProductsSelection.jsx";
import { cn } from "@/lib/utils";

import { Section } from "../../components/ui/section";
import BannersCarousel from "@/components/home/BannersCarousel";
import SeoText from "../../components/home/SeoText/SeoText";

export default function (props) {
  const { selections, store } = props;

  return (
    <>
      <Head>
        <title>
          Воздушные шары с доставкой по Красноярску | Шарарам.рф | Магазин все
          для праздника
        </title>
        <meta
          name="description"
          content="Воздушные шары с доставкой в Красноярске покупайте в Магазин все для праздника Шарарам.рф или заказывайте воздушные шары с доставкой по телефону 8 (902) 927-42-57. Купить воздушные шары в Красноярске для яркого и незабываемого праздника: шары на день рождения, шары на выписку, тематические праздники, мини шары фигуры, шары фигуры, ходячие фигуры, шары цифры, шары фольга с рисунком, wow коробки, праздничные товар, корпоративное оформление, фотозоны из воздушных шаров"
        />
      </Head>

      <Banner />

      <Section className="px-2 xl:px-0">
        <BannersCarousel />
      </Section>

      <Section>
        <div className="space-y-8 px-2 xl:px-0">
          <div className="grid lg:grid-cols-3 gap-6 py-4 xl:py-12">
            {selections.map((s) => (
              <div
                className="flex bg-gray-50 rounded-3xl overflow-hidden shadow cursor-pointer items-center"
                key={`selection-thumb-${s.taxon.id}`}
                onClick={() => {
                  window.scrollTo({
                    top: document
                      .getElementById(`selection-${s.taxon.id}`)
                      .getBoundingClientRect().top,
                    behavior: "smooth",
                  });
                }}
              >
                <img src={s.thumb} className="size-25 rounded-3xl" />
                <div className="p-2 space-y-2">
                  <div className="text-xl xl:text-lg leading-5">{s.title}</div>
                  <div
                    className="text-xs xl:text-xs leading-tight text-gray-600 line-clamp-3 [&>div]:line-clamp-3"
                    dangerouslySetInnerHTML={{
                      __html: s.taxon.description.body,
                    }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </Section>

      {selections.map((selection, i) => {
        return (
          <div className={cn("odd:bg-gray-50 pt-8")}>
            <div className="container mx-auto px-2 xl:px-0">
              <ProductsSelection selection={selection} />
            </div>
          </div>
        );
      })}

      <Services />
      <Features />
      <SeoText />
    </>
  );
}

function Banner() {
  const { store } = usePage().props;
  const { banner_image } = store;
  if (!banner_image) return null;

  return (
    <Section className="xl:container mx-auto py-4 px-2 xl:px-0">
      <img src={banner_image} className="rounded-xl" />
    </Section>
  );
}
